import { Client } from 'api/utils';

export const getOrdersFromGroupId = async (
  orderGroupId: number,
): Promise<number[]> => {
  const response = await Client.get(`/OrderGroups/${orderGroupId}`);
  return response.data.orderIds;
};
